import { render, staticRenderFns } from "./Circulos.vue?vue&type=template&id=3a20b52e&scoped=true"
import script from "./Circulos.vue?vue&type=script&lang=js"
export * from "./Circulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20b52e",
  null
  
)

export default component.exports